import React, { Fragment, ReactElement } from 'react';
import { Outlet } from 'react-router';
import ErrorLayout from '../../../components/error-layout/error-layout.component';
import ErrorFallback from '../error-fallback/error-fallback.component';
import Footer from '../footer/footer.component';

const InitialContent: ReactComponent = (): ReactElement => (
  <Fragment>
    <ErrorLayout component={ErrorFallback}>
      <Outlet />
    </ErrorLayout>
    <Footer />
  </Fragment>
);

export default InitialContent;
